import lib from "../js-lib/lib";

const Lightbox = {
  scope: (state) => {
    lib.qsa(".x-lightbox").forEach((elem, i) => {
      // Collect Lightboxes and Lightbox Links
      state.lightboxes[i] = elem; // Assign Elements to Lightboxes State
      state.lightboxes[i]["open"] = false; // Closed Lightbox State
      state.lightboxes[i]["link"] = elem.previousElementSibling; // Select the Link as the Lightbox Target
      state.lightboxes[i]["close"] = lib.qs(".close", elem);
      state.lightboxes[i]["overlay"] = lib.qs(".overlay", elem);
    });
    Lightbox.listeners(state);
  },
  open: (elem) => {
    elem.open == true
      ? elem.classList.add("open")
      : elem.classList.remove("open");
  },
  listeners: (state) => {
    [...state.lightboxes].forEach((elem, i) => {
      state.lightboxes[i].link.addEventListener("click", (e) => {
        e.preventDefault();
        state.lightboxes[i].open = true;
        Lightbox.open(state.lightboxes[i]);
        document.body.style = "overflow: hidden";
      });
      [state.lightboxes[i].close, state.lightboxes[i].overlay].forEach(
        (close) => {
          close.addEventListener("click", () => {
            state.lightboxes[i].open = false;
            Lightbox.open(state.lightboxes[i]);
            document.body.style = "overflow: visable";
          });
        }
      );
    });
  },
  render: (state) => {
    let i = 0; // Re Render ALL states of ALL lightboxes
    while (i < state.lightboxes.length) {
      Lightbox.open(state.lightboxes[i]);
      i++;
    }
  },
};

export { Lightbox as default };
